import { stringHelper } from "@tweddle-se-team/common/helpers";
import { Nav } from "rsuite";

const { dashCase } = stringHelper;

const NavigationItems = ({ router, items = [] }) => {
  return (
    <>
      {items.map((item) => (
        <Nav.Item
          key={`nav-${item.name}`}
          onClick={() => router.push(item?.route)}
          data-testid={`nav-item-${dashCase(item?.name)}`}
        >
          {item.name}
        </Nav.Item>
      ))}
    </>
  );
};

export default NavigationItems;